"use client";
// PagesShell — Group layout'un client shell'i.
// Layout kendisi Server Component; sadece isPurePage + nav state için client gerekiyor.
import SidebarActions from "../components/common/sections/SidebarActions";
import Footer from "../components/layout/footer/Footer";
import Header from "../components/layout/header/Header";
import MobileNav from "../components/layout/mobileNav/MobileNav";
import useMobile from "../lib/features/mobile/mobile.hook";
import useMobileNav from "../hooks/useMobileNav";
import { ReactNode } from "react";

const PagesShell = ({ children }: { children: ReactNode }) => {
  const { isPurePage } = useMobile();
  const { isOpen, onClose } = useMobileNav();

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header: conditional render — sticky top-0 wrapper div içinde çalışmaz
          (parent yüksekliği = header yüksekliği → sticky range = 0) */}
      {!isPurePage && <Header />}
      {!isPurePage && <MobileNav isOpen={isOpen} onClose={onClose} />}
      <main className="grow">
        {children}
        {!isPurePage && <SidebarActions />}
      </main>
      {!isPurePage && <Footer />}
    </div>
  );
};

export default PagesShell;